import React, { useState, useEffect } from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page } from '@syncfusion/ej2-react-grids';

import {
  dataRawGrid, dataSpellCheckedGrid, dataClassifiedSentimentGrid,
  dataClassifiedIntentGrid, dataClassifiedTotalGrid
} from '../data/dummy';
import Papa from 'papaparse';

const DataPreview = ({ previewType }) => {
  const toolbarOptions = ['Search'];

  const editing = { allowDeleting: true, allowEditing: true };
  const dataRaw = '/data/dataset_raw.csv';
  const dataSpellChecked = '/data/dataset_spellChecked.csv';
  const dataClassifiedSentiment = '/data/dataset_classified_sentiment.csv';
  const dataClassifiedIntent = '/data/dataset_classified_intent.csv';
  const dataClassifiedTotal = '/data/dataset_classified_total.csv';

  let dataset = dataRaw;
  let dataGrid = dataRawGrid;
  

  console.log(`previewType: ${previewType}`);
  if (previewType == 'raw') {
    dataset = dataRaw;
    dataGrid = dataRawGrid;
  } else if (previewType == 'spellchecked') {
    dataset = dataSpellChecked;
    dataGrid = dataSpellCheckedGrid;
  } else if (previewType == 'classifiedSentiment') {
    dataset = dataClassifiedSentiment;
    dataGrid = dataClassifiedSentimentGrid;
  } else if (previewType == 'classifiedIntent') {
    dataset = dataClassifiedIntent;
    dataGrid = dataClassifiedIntentGrid;
  } else if (previewType == 'classifiedTotal') {
    dataset = dataClassifiedTotal;
    dataGrid = dataClassifiedTotalGrid;
  }




  const [reviewData, setReviewsData] = useState([]);
  useEffect(() => {



    fetch(dataset)
      .then((response) => response.text())
      .then((data) => {
        Papa.parse(data, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // CSV 데이터를 필요한 형식으로 변환


            console.log("CSV Headers:", results.meta.fields);
            const formattedData = results.data.map((row, index) => ({
              ReviewID: index + 1,
              ReviewerName: row['ReviewerName'] || '',
              ReviewDate: row['ReviewDate'] || '',
              ReviewContent: row['ReviewContent'] || '',
              ReviewRate: row['Rating'] || '',
              ReviewContent_SpellChecked: row['ReviewContent_SpellChecked'] || '',
              Sentiment: row['Sentiment'] || '',
              Intent: row['Intent'] || '',
            }));

            setReviewsData(formattedData);
          },
        });
      })
      .catch((error) => console.error('Error fetching the CSV file:', error));
  }, [previewType]);

  return (

    <div className="m-1 md:m-1 p-1 md:p-5 bg-white rounded-3xl">
      <GridComponent
        dataSource={reviewData}
        width="auto"
        allowPaging
        allowSorting
        allowTextWrap  // 줄바꿈 옵션 활성화
        pageSettings={{ pageCount: 5, pageSize: 10 }}
        editSettings={editing}
        toolbar={toolbarOptions}
      // rowHeight={50} // Adjust the row height here
      >
        <ColumnsDirective>
          {dataGrid.map((item, index) => <ColumnDirective key={index} {...item} headerTextAlign="Center" />)}
        </ColumnsDirective>
        <Inject services={[Search, Page]} />

      </GridComponent>
    </div>

  );
};
export default DataPreview;
